import greiffPremiumCf from './GreiffPremiumCf.jpeg';

export const greiffPremiumCfImpressions = {
    greiffPremiumCf,
};
